<div>
  <div class="review">
    <div class="review-heading">
      <div   class="review-header">
        <div  class="cancel-button">
          <ngx-skeleton-loader appearance="line" [theme]="{ width: '80%', height: '28px' }"></ngx-skeleton-loader>
        </div>
        <div class="profile">
          <ngx-skeleton-loader
            appearance="circle"
            [theme]="{
              width: '100px',
              height: '100px'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div  class="sign-in">
          <ngx-skeleton-loader appearance="line" [theme]="{ width: '80%', height: '28px' }"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="review-info-loading" >
      <ngx-skeleton-loader
        appearance="line"
        count="12"
        [theme]="{
          width: '90%',
          height: '30px'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>
